import type { LucideIcon } from "lucide-react";

const SummaryCard: React.FC<{
  icon: LucideIcon;
  label: string;
  value: string;
  barGradient: string;
  iconBg: string;
  iconColor: string;
  labelColor?: string;
  valueColor?: string;
  emphasized?: boolean;
  className?: string;
}> = ({
  icon: Icon,
  label,
  value,
  barGradient,
  iconBg,
  iconColor,
  labelColor = "text-slate-500",
  valueColor = "text-slate-800",
  emphasized = false,
  className = "",
}) => (
    <div
      className={`bg-white p-5 rounded-2xl border relative overflow-hidden group transition-all duration-300 ${emphasized
          ? "shadow-md hover:shadow-xl border-primary/20"
          : "shadow-sm hover:shadow-lg border-slate-200/60"
        } ${className}`}
    >
      <div
        className={`absolute top-0 left-0 right-0 h-1 rounded-t-2xl bg-linear-to-r ${barGradient}`}
      ></div>
      {emphasized && (
        <div className="absolute -right-4 -bottom-4 w-24 h-24 bg-primary/5 rounded-full blur-2xl"></div>
      )}
      <div className="flex justify-between items-start mb-3 relative z-10">
        <div className={`p-2.5 rounded-xl ${iconBg} ${iconColor}`}>
          <Icon className="w-5 h-5" />
        </div>
      </div>
      <p
        className={`text-xs font-semibold uppercase tracking-wider relative z-10 ${labelColor}`}
      >
        {label}
      </p>
      <p
        className={`text-base sm:text-xl xl:text-2xl font-extrabold mt-1 relative z-10 ${valueColor}`}
      >
        {value}
      </p>
    </div>
  );

export default SummaryCard;
